var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartlyCloudyDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.87 85.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5b952;}.cls-2{fill:#e5f1fb;}.cls-3,.cls-4,.cls-5{fill:none;stroke:#000;stroke-miterlimit:10;}.cls-3,.cls-5{stroke-width:5px;}.cls-4,.cls-5{stroke-linecap:round;}.cls-4{stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "partly-cloudy-dayAsset 137colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.92,37.6c-.07,1.53-11.49,2.68-23.87,8.17C26.6,50,23.24,53,23.24,42.66A18.73,18.73,0,0,1,42,23.94C52.31,23.94,60.31,29.3,59.92,37.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93,58.42a10,10,0,0,0-1.94-3.79,9.9,9.9,0,0,0-2.47-2.32,10.51,10.51,0,0,0-4.21-1.56c-.21,0-.47-.33-.56-.56A10.27,10.27,0,0,0,72.9,43.43a18.22,18.22,0,0,0-3.62,1A1.08,1.08,0,0,1,68.07,44a12.23,12.23,0,0,0-4.7-4,13.15,13.15,0,0,0-2.09-.82c-.37-.11-.74-.21-1.12-.29a10.24,10.24,0,0,0-3-.19,12.17,12.17,0,0,0-1.22.14,10.62,10.62,0,0,0-1.18.25l-.13,0a21.36,21.36,0,0,0-4.26,2.1,30.81,30.81,0,0,0-3.5,3.46l-.1,0a11.55,11.55,0,0,0-5.29-1.37,9.84,9.84,0,0,0-4.66,1.12A11.06,11.06,0,0,0,32,49.52a2.22,2.22,0,0,1-1.38,1.07,11.2,11.2,0,0,0-2.89,1,9.68,9.68,0,0,0-3.63,3.26c-.14.22-.3.44-.43.68A12.12,12.12,0,0,0,22.28,59a9.1,9.1,0,0,0,0,3.47A10.31,10.31,0,0,0,30.74,71a1.18,1.18,0,0,1,1,.87,10.25,10.25,0,0,0,8.48,6.63,10.11,10.11,0,0,0,5.85-1,1,1,0,0,1,1.28.32A12.66,12.66,0,0,0,68,78a1,1,0,0,1,1.28-.33,10.34,10.34,0,0,0,14.46-5.71.84.84,0,0,1,.79-.59A10.35,10.35,0,0,0,93,58.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93,58.42a10,10,0,0,0-1.94-3.79,9.9,9.9,0,0,0-2.47-2.32,10.51,10.51,0,0,0-4.21-1.56c-.21,0-.47-.33-.56-.56A10.27,10.27,0,0,0,72.9,43.43a18.22,18.22,0,0,0-3.62,1A1.08,1.08,0,0,1,68.07,44a12.23,12.23,0,0,0-4.7-4,13.15,13.15,0,0,0-2.09-.82c-.37-.11-.74-.21-1.12-.29a10.24,10.24,0,0,0-3-.19,12.17,12.17,0,0,0-1.22.14,10.62,10.62,0,0,0-1.18.25l-.13,0a21.36,21.36,0,0,0-4.26,2.1,30.81,30.81,0,0,0-3.5,3.46l-.1,0a11.55,11.55,0,0,0-5.29-1.37,9.84,9.84,0,0,0-4.66,1.12A11.06,11.06,0,0,0,32,49.52a2.22,2.22,0,0,1-1.38,1.07,11.2,11.2,0,0,0-2.89,1,9.68,9.68,0,0,0-3.63,3.26c-.14.22-.3.44-.43.68A12.12,12.12,0,0,0,22.28,59a9.1,9.1,0,0,0,0,3.47A10.31,10.31,0,0,0,30.74,71a1.18,1.18,0,0,1,1,.87,10.25,10.25,0,0,0,8.48,6.63,10.11,10.11,0,0,0,5.85-1,1,1,0,0,1,1.28.32A12.66,12.66,0,0,0,68,78a1,1,0,0,1,1.28-.33,10.34,10.34,0,0,0,14.46-5.71.84.84,0,0,1,.79-.59A10.35,10.35,0,0,0,93,58.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.77,39A18.84,18.84,0,0,0,23.35,42a18.65,18.65,0,0,0,3.09,10.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 42.15,
    y1: 14.23,
    x2: 42.15,
    y2: 6.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 14.23,
    y1: 42.15,
    x2: 6.07,
    y2: 42.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 22.41,
    y1: 22.41,
    x2: 16.64,
    y2: 16.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 67.66,
    y1: 16.64,
    x2: 61.89,
    y2: 22.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 54.63,
    y1: 11.47,
    x2: 58.28,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 11.47,
    y1: 29.67,
    x2: 2.5,
    y2: 26.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 29.28,
    y1: 11.63,
    x2: 25.52,
    y2: 2.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 11.63,
    y1: 55.02,
    x2: 2.71,
    y2: 58.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 81.59,
    y1: 25.52,
    x2: 72.67,
    y2: 29.28
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyCloudyDay);
export default __webpack_public_path__ + "static/media/partly-cloudy-day.1b7e30503cbfe9b1328f1823f97726fc.svg";
export { ForwardRef as ReactComponent };